/**
 * Track the on-screen keyboard height and expose it as the CSS custom property
 * --keyboard-inset on :root, so the ElementSwitcher and toasts sit just above
 * the soft keyboard. Uses visualViewport (Android Chrome); falls back to the
 * env(keyboard-inset-height) default baked into the CSS variable.
 */
import { useEffect } from "react";

export function useKeyboardInset(): void {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const root = document.documentElement;
    const update = () => {
      // Space hidden below the visual viewport ≈ keyboard height.
      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty("--keyboard-inset", `${Math.round(inset)}px`);
    };

    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      root.style.removeProperty("--keyboard-inset");
    };
  }, []);
}
